import { render, staticRenderFns } from "./futreport.vue?vue&type=template&id=2f63cf20&scoped=true&"
import script from "./futreport.vue?vue&type=script&lang=js&"
export * from "./futreport.vue?vue&type=script&lang=js&"
import style1 from "./futreport.vue?vue&type=style&index=1&id=2f63cf20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f63cf20",
  null
  
)

export default component.exports